var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('FBarDate',{attrs:{"disabledNav":"","lastUpdate":_vm.updatedAt,"showDay":""},on:{"change":this.getProductsList}}),(_vm.products)?_c('FTable',{staticStyle:{"margin-top":"10px"},attrs:{"items":_vm.products || []}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }